import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "text-subtitle-underline" }, "最近見た動画（閲覧履歴）", -1)
const _hoisted_2 = { class: "grid grid-cols-2 md:grid-cols-4 gap-4" }
const _hoisted_3 = { class: "text-right" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" すべての閲覧履歴を見る> ")
const _hoisted_5 = {
  key: 1,
  class: "h-40 px-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_video_thumbnail = _resolveComponent("video-thumbnail")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (_ctx.toArray(_ctx.watchHistories).length)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.watchHistories, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.id
              }, [
                (item.video)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: `/video/${item.video.id}`
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_video_thumbnail, {
                          video: item.video
                        }, null, 8, ["video"])
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_router_link, {
              to: "/video/watch-history",
              class: "text-link text-sm"
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            })
          ])
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, " 最近見た動画はありませんでした。 "))
  ], 64))
}